



































































































































































































































































































































































































































































































































import IGood from '@/store/models/IGood';
import IInboundDetail from '@/store/models/IInboundDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IListPalletType from '@/store/models/IListPalletType';
import IInbound from '@/store/models/IInbound';
import moment from 'moment';
import IAuthentication from '@/store/models/IAuthentication';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import IBORInboundDetailType from '@/store/models/IBORInboundDetailType';
import InboundDetailMapper from '@/components/selectors/Inbounds/InboundDetailMapper.vue';
import { BORGood } from '@/store/models/BORGood';
import { BORGoodSave } from '@/store/models/BORGoodSave';
import * as XLSX from 'xlsx';

@Component({
    components: {
        Snackbar,
        vueDropzone: vue2Dropzone,
        InboundDetailMapper
    }
})
export default class InboundDetailSelector extends Vue {
    languageText: string = "";
    Language: string = "";
    menu2: boolean = false;
    searchInboundDetail: string = "";
    dialog: boolean = false;
    dialogPrinting: boolean = false;
    selectedFormatToPrint: string = "";
    isValid: boolean = true;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;

    dropzoneOptions: any = {
        url: '/upload',
        thumbnailWidth: 150,
        maxFilesize: 25,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        maxFiles: 1,
        previewsContainer: false,
        autoProcessQueue: false
    };

    headers: any = [
        { text: 'Good', align: 'start', value: 'goodName' },
        { text: 'Good code', value: 'goodCode' },
        { text: 'Sku', value: 'sku' },
        { text: 'Pallet', value: 'palletName' },
        { text: 'Pallet amount', value: 'palletsAmount' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Total cases', value: 'totalCases' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'In delivery note', value: 'inDeliveryNote' },
        { text: 'Cases loss', value: 'casesLoss' },
        { text: 'Best before date', value: 'bestBeforeDate' },
        { text: 'Weight per pallet (Kg)', value: 'weight' },
        { text: 'Language', value: 'language' },
        { text: 'Douana Document', value: 'documentation' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];

    editedIndex: number = -1;

    editedItem: IInboundDetail = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: null,
        inDeliveryNote: 0,
        language: "",
        documentation: false,
        sku: "",
        casesLoss: 0,
        weight: 0,
        goodCode: ""
    };

    defaultItem: IInboundDetail = {
        id: "",
        idInbound: "",
        idGood: "",
        goodName: "",
        idListPallet: "",
        palletName: "",
        palletsAmount: 0,
        casesPerPallet: 0,
        totalCases: 0,
        goodsPerCase: 0,
        totalGoods: 0,
        bestBeforeDate: null,
        inDeliveryNote: 0,
        language: "",
        documentation: false,
        sku: "",
        casesLoss: 0,
        weight: 0,
        goodCode: ""
    };

    @Prop({ type: Array, required: true })
    InboundDetailList!: IInboundDetail[];

    @Prop({ type: Array, required: true })
    Permissions!: IRolePermission[];

    @Prop({ type: Array, required: true })
    PalletTypesList!: IListPalletType[];

    @Prop({ type: Array, required: true })
    GoodList!: IGood[];

    @Prop({ type: Array, required: true })
    BORInboundDetails!: IBORInboundDetailType[];

    @Prop()
    SelectedInbound!: IInbound;

    @Prop({ type: String, default: "" })
    InboundId!: string;

    @Prop()
    value!: IInboundDetail | null;

    @Prop({ type: Boolean, default: false })
    CanModifyCompletedInbounds!: boolean;

    @Prop({ type: Boolean, default: false })
    BORInboundDetailParseActive!: boolean;

    @Prop({ type: Array, required: true })
    SuggestedGoods!: BORGood[];

    @Prop({ type: Boolean, default: false })
    IsUploading!: boolean;

    @Prop({ type: Boolean, default: false })
    ImportExcelActive!: boolean;

    @Prop()
    CompanyId!: string;

    minBestBeforeDate: string = (() => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 1);

        return new Date(today.getTime() - today.getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    })();

    selectedInboundDetail: IInboundDetail[] = [];
    selectedGood: IGood = {} as IGood;
    selectedPalletId: string = "";
    minPalletAmount: number = 0;
    bestBeforeDate: string = "";
    importGoodsDialog: boolean = false;
    files: any[] = [];
    manualWeightEdited: boolean = false;
    uploadXlsDialog: boolean = false;
    xlsFile: File | null = null;
    xlsSelectedPallet: IListPalletType = {} as IListPalletType;
    originalPalletName: string = "";
    xlsErrors: string[] = [];

    xlsPreviewHeaders: any[] = [
        { text: 'Row', value: 'rowNumber' },
        { text: 'Good code', value: 'goodCode' },
        { text: 'Weight', value: 'weight' },
        { text: 'Cases', value: 'cases' },
        { text: 'Batch code', value: 'batchCode' },
        { text: 'Matched good', value: 'matchedGoodName' },
        { text: 'BBD', value: 'bbd' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Message', value: 'message', sortable: false }
    ];

    xlsPreviewRows: Array<{
        rowNumber: number;
        goodCode: string;
        batchCode: string;
        weight: number | null;
        cases: number | null;
        bbd: string | null;
        matchedGoodId: string | null;
        matchedGoodName: string | null;
        isValid: boolean;
        message: string;
    }> = [];

    async mounted() {
        await this.SetLanguageText();
    }

    get isEditNotSource(): boolean {
        return this.dialog && this.editedIndex > -1 && !this.isCompanySource;
    }

    get isEditing(): boolean {
        return this.editedIndex > -1;
    }

    @Watch('SelectedInbound')
    onInboundChanged() {
        this.files = [];
    }

    @Watch('languageText')
    onLanguageTextChanged(newValue: string) {
        this.headers = this.headers.map((header: any) => {
            if (header.value === 'language') {
                return {
                    text: newValue,
                    align: header.align,
                    value: header.value
                };
            }
            return header;
        });
    }

    onMaxFilesReached(files: any[]) {
        this.$emit("showMessageWarning", "A maximum of 1 files may be uploaded.");
        if (files.length > 1) {
            files.slice(10).forEach((file) => {
                this.removeFile(file);
            });
        }
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
    }

    appendFile(file: any) {
        if (this.files.length > 0) {
            this.removeFile(0);
        }
        this.files.push(file);
    }

    showImportGoodsDialog() {
        this.importGoodsDialog = true;
        this.$emit('getBORInboundDetails');
    }

    closeImportGoodsDialog() {
        this.files = [];
        this.importGoodsDialog = false;
    }

    importGoods() {
        this.importGoodsDialog = false;
    }

    get canConfirmXlsImport(): boolean {
        if (!this.xlsPreviewRows.length) return false;
        if (!this.xlsSelectedPallet || !this.xlsSelectedPallet.id) return false;
        return this.xlsPreviewRows.some(r => r.isValid);
    }

    get BestBeforeDateFormatted() {
        return this.formatDate(this.bestBeforeDate);
    }

    get showDeleteButton(): boolean {
        return this.BORInboundDetails.length === 0 && !this.IsUploading && this.files.length > 0;
    }

    get showValidateButton(): boolean {
        return this.BORInboundDetails.length > 0;
    }

    get TotalWeight() {
        const totalWeight = this.InboundDetailList.reduce((sum, item) => {
            const pallets = Number(item.palletsAmount) || 0;
            const weightPerPallet = Number(item.weight) || 0;
            return sum + pallets * weightPerPallet;
        }, 0);

        return totalWeight.toFixed(2);
    }

    get isEditSourceWithMissingPallet(): boolean {
        return this.dialog &&
            this.editedIndex > -1 &&
            this.isCompanySource &&
            !!this.editedItem.idListPallet &&
            !(this.PalletTypesList || []).some(p => p.id === this.editedItem.idListPallet);
    }

    get palletInfoLabel(): string {
        if (this.isEditNotSource) {
            return 'Original pallet (Source)';
        }

        if (this.isEditSourceWithMissingPallet) {
            return 'Current pallet selected by Destination';
        }

        return 'Pallet';
    }

    openUploadXlsDialog() {
        this.uploadXlsDialog = true;
        this.xlsFile = null;
        this.xlsSelectedPallet = {} as IListPalletType;
        this.xlsErrors = [];
        this.xlsPreviewRows = [];
    }

    closeUploadXlsDialog() {
        this.uploadXlsDialog = false;
        this.xlsFile = null;
        this.xlsSelectedPallet = {} as IListPalletType;
        this.xlsErrors = [];
        this.xlsPreviewRows = [];
    }

    HasRightModifyCompletedInbounds() {
        return this.Permissions[0].isWritable &&
            this.SelectedInbound &&
            (
                this.SelectedInbound.statusName !== 'Completed' ||
                this.CanModifyCompletedInbounds
            );
    }

    bestBeforeDateChanged() {
        this.bestBeforeDate = "";
        this.editedItem.bestBeforeDate = null;
    }

    getGoodCode(code: string | null | undefined) {
        if (code) {
            return " - " + code;
        }
        return "";
    }

    getGoodSku(sku: string | null | undefined) {
        if (sku) {
            return " - " + sku;
        }
        return "";
    }

    formatDate(date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate(date: string) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    GetValueDocumentation(documentationNeeded: boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }

        return 'No';
    }

    duplicateInboundDetail(item: IInboundDetail) {
        if (!this.Permissions[0].isWritable) {
            this.showMessageWarning("You don't have permission to duplicate this record.");
            return;
        }

        const duplicated = Object.assign({}, item);
        duplicated.id = "";
        duplicated.inDeliveryNote = 0;
        duplicated.bestBeforeDate = item.bestBeforeDate ? new Date(item.bestBeforeDate) : null;
        duplicated.documentation = this.IsDouanaDocumentRequiredByInboundType ? true : item.documentation;

        this.selectedGood = this.GoodList.find(g => g.id === duplicated.idGood) as IGood;
        const resolvedPallet = this.resolveSelectedPallet(duplicated);

        this.bestBeforeDate = duplicated.bestBeforeDate
            ? moment(new Date(duplicated.bestBeforeDate)).format("YYYY-MM-DD")
            : "";

        this.editedIndex = -1;
        this.editedItem = Object.assign({}, duplicated);

        if (this.bestBeforeDate === "" || this.bestBeforeDate === null) {
            this.editedItem.bestBeforeDate = null;
        } else {
            this.editedItem.bestBeforeDate = new Date(this.bestBeforeDate);
        }

        this.editedItem.idGood = this.selectedGood.id;
        this.editedItem.goodName = this.selectedGood.name;
        this.editedItem.sku = this.selectedGood.sku;

        this.selectedPalletId = resolvedPallet && resolvedPallet.id
            ? resolvedPallet.id
            : "";

        if (!this.selectedPalletId) {
            const unknownPallet = this.PalletTypesList.find(
                p => p.name && p.name.toLowerCase() === "unknown"
            ) as IListPalletType;

            if (unknownPallet) {
                this.selectedPalletId = unknownPallet.id;
                this.editedItem.idListPallet = unknownPallet.id;
                this.editedItem.palletName = unknownPallet.name;
            }
        } else {
            this.editedItem.idListPallet = resolvedPallet.id;
            this.editedItem.palletName = resolvedPallet.name;
        }

        this.editedItem.idInbound = this.InboundId || this.SelectedInbound.id;

        this.$emit("saveInboundDetail", this.editedItem);
        this.showMessageInfo("Inbound detail duplicated successfully.");
    }

    uploadToBoldR() {
        if (this.files.length === 0) {
            this.showMessageWarning("Please select a document before uploading to BoldR");
            return;
        }

        if (this.BORInboundDetails.length > 0) {
            this.showMessageWarning("Cannot import. BORInboundDetails already contains records.");
            return;
        }

        let formData = new FormData();
        formData.append("files", this.files[0], this.files[0].name);

        this.$emit('uploadFileToBoldR', formData, this.files[0]);
    }

    async updateExistingProduct(item: IBORInboundDetailType) {
        await new Promise<void>((resolve, reject) => {
            this.$emit("updateExistingProduct", item, resolve, reject);
        });
    }

    cloneBORInboundDetail(item: IBORInboundDetailType) {
        this.$emit('cloneBORInboundDetail', item);
    }

    createNewProducts(items: BORGoodSave[]) {
        this.$emit('createNewProducts', items);
    }

    deleteImport() {
        this.files = [];
        this.$emit('deleteImport');
    }

    importFinal(inboundDetails: IBORInboundDetailType[]) {
        this.$emit('importFinal', inboundDetails);
        this.files = [];
        this.closeImportGoodsDialog();
    }

    searchSugestionGoods(goodName: string) {
        this.$emit('searchSugestionGoods', goodName);
    }

    validateBORInboundDetails(items: IBORInboundDetailType[]) {
        this.$emit('validateBORInboundDetails', items);
    }

    saveBORInboundDetails(items: IBORInboundDetailType[]) {
        this.$emit('saveBORInboundDetails', items);
    }

    deleteBORInboundDetail(item: IBORInboundDetailType) {
        this.$emit('deleteBORInboundDetail', item, true);
    }

    deleteMultiple(inboundDetails: IBORInboundDetailType[]) {
        this.$emit('deleteMultiple', inboundDetails);
    }

    async SetLanguageText() {
        if (this.languageText === "") {
            let userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
            let settingsCompany = SettingsCompany.Settings.InboundDetailLanguageText;
            let settingsCompanyApi = new SettingsCompanyApi("Outbounds");
            let setting: ISettingsCompany[] = await settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingsCompany);

            if (setting.length === 0) {
                this.languageText = "Language";
            } else {
                this.languageText = setting[0].value;
            }
        }
    }

    get TotalCases() {
        let totalCases: number = this.InboundDetailList.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
        return totalCases;
    }

    get TotalPallets() {
        const totalPallets: number = this.InboundDetailList
        .filter(item => {
            const palletType = this.PalletTypesList.find(p => p.id === item.idListPallet);

            if (palletType) {
                return palletType.notBillable !== true;
            }

            // Fallback para datos antiguos o pallets no encontrados
            const palletName = (item.palletName || "").toLowerCase();
            return palletName !== "colli" && palletName !== "case";
        })
        .reduce((sum, current) => Number(sum) + Number(current.palletsAmount || 0), 0);

        return totalPallets;
    }

    get IsDouanaDocumentRequiredByInboundType(): boolean {
        const inbound: any = this.SelectedInbound || {};

        const inboundType = (
            inbound.type ||
            inbound.listTypesInboundsName ||
            inbound.inboundType ||
            ""
        ).toString().trim().toLowerCase();

        return inboundType === "ivv" ||
            inboundType === "agp" ||
            inboundType === "entrepot";
    }

    get TotalGoods() {
        let totalGoods: number = this.InboundDetailList.reduce((sum, current) => Number(sum) + Number(current.totalGoods), 0);
        return totalGoods;
    }

    get formTitle() {
        return this.editedIndex === -1 ? 'New Inbound Detail' : 'Edit Inbound Detail';
    }

    applyDouanaDocumentDefault(): void {
        if (this.IsDouanaDocumentRequiredByInboundType) {
            this.editedItem.documentation = true;
        }
    }

    GetValue(documentation: boolean) {
        if (documentation !== null) {
            if (documentation.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue: IInboundDetail | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedInboundDetail = [];
        } else {
            this.selectedInboundDetail = [newValue];
        }
    }

    getColor(item: IInboundDetail): string {
        if (item.inDeliveryNote === null) {
            item.inDeliveryNote = 0;
            return 'orange';
        } else if (item.inDeliveryNote < item.totalCases) {
            return 'orange';
        } else if (item.inDeliveryNote === item.totalCases) {
            return 'green';
        }

        item.inDeliveryNote = 0;
        return 'orange';
    }

    ToDateFormat(date: string): string {
        if (date === "" || date === null) {
            return "";
        }

        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    HasPermissionToSave(): boolean {
        if (Object.keys(this.SelectedInbound).length !== 0) {
            if (this.Permissions[0].isWritable) {
                return true;
            }
        }

        return false;
    }

    @Watch('selectedGood')
    onChangeSelectedGood() {
        this.editedItem.goodsPerCase = this.selectedGood.amountPerBox;

        if (this.selectedGood && this.selectedGood.weight > 0) {
            const cases = this.editedItem.casesPerPallet > 0 ? this.editedItem.casesPerPallet : 0;
            this.editedItem.weight = cases * this.selectedGood.weight;
        } else {
            this.editedItem.weight = 0;
        }

        this.manualWeightEdited = false;
    }

    @Watch('editedItem.casesPerPallet')
    onCasesPerPalletChanged() {
        if (!this.manualWeightEdited) {
            if (this.selectedGood && this.selectedGood.weight > 0) {
                this.editedItem.weight = this.editedItem.casesPerPallet * this.selectedGood.weight;
            } else {
                this.editedItem.weight = 0;
            }
        }
    }

    get CasesPerPallet() {
        return this.editedItem.casesPerPallet;
    }

    get CalculateTotalCases() {
        if (this.editedItem.palletsAmount > 0 && this.CasesPerPallet > 0) {
            this.editedItem.totalCases = this.editedItem.palletsAmount * this.CasesPerPallet;
            return this.editedItem.palletsAmount * this.CasesPerPallet;
        }

        return 0;
    }

    get CalculateGoodsPerCase() {
        if (this.selectedGood) {
            if (this.editedItem.goodsPerCase > 0) {
                return this.editedItem.goodsPerCase;
            }

            if (this.selectedGood.amountPerBox > 0) {
                this.editedItem.goodsPerCase = this.selectedGood.amountPerBox;
                return this.selectedGood.amountPerBox;
            }
        }

        return 0;
    }

    get CalculateTotalGoods() {
        if (this.CalculateTotalCases > 0 && this.CalculateGoodsPerCase > 0) {
            this.editedItem.totalGoods = this.CalculateTotalCases * this.CalculateGoodsPerCase;
            return this.CalculateTotalCases * this.CalculateGoodsPerCase;
        }

        return 0;
    }

    resetInboundDetail() {
        this.selectedInboundDetail = [];
        this.selectedPalletId = "";
        this.selectedGood = {} as IGood;
        this.minPalletAmount = 0;
        this.bestBeforeDate = "";
        this.editedIndex = -1;
        this.originalPalletName = "";

        this.editedItem = Object.assign({}, this.defaultItem);

        this.applyDouanaDocumentDefault();

        this.$emit('resetInboundDetail');
    }
    editInboundDetail(item: IInboundDetail, dbox = true) {
        if (this.selectedInboundDetail.length > 0) {
            this.editedIndex = this.InboundDetailList.indexOf(item);
            this.selectedGood = this.GoodList.find(p => p.id === item.idGood) as IGood;
            this.originalPalletName = item.palletName || '';

            if (item.bestBeforeDate === null) {
                this.bestBeforeDate = "";
            } else {
                this.bestBeforeDate = moment(new Date(item.bestBeforeDate)).format('YYYY-MM-DD');
            }

            this.editedItem = Object.assign({}, item);
            this.applyDouanaDocumentDefault();
            this.selectedPalletId = item.idListPallet;

            if (this.editedItem.documentation === null) {
                this.editedItem.documentation = false;
            }

            if (item.inDeliveryNote === 0) {
                this.minPalletAmount = 0;
            } else {
                this.minPalletAmount = item.palletsAmount - (item.inDeliveryNote / item.casesPerPallet);

                if (this.minPalletAmount === 0) {
                    this.minPalletAmount = item.palletsAmount;
                }
            }

            this.dialog = true;
        }
    }

    saveInboundDetail() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.bestBeforeDate === "" || this.bestBeforeDate === null) {
                this.editedItem.bestBeforeDate = null;
            } else {
                this.editedItem.bestBeforeDate = new Date(this.bestBeforeDate);
            }

            this.applyDouanaDocumentDefault();
            this.editedItem.idGood = this.selectedGood.id;
            this.editedItem.goodName = this.selectedGood.name;
            this.editedItem.sku = this.selectedGood.sku;

            if (this.editedItem.idGood === null || this.editedItem.idGood === undefined) {
                this.showMessageWarning('Good is required, please select a good.');
            } else {
                let selectedPallet = this.PalletTypesList.find(p => p.id === this.selectedPalletId);

                if (!selectedPallet && this.editedIndex > -1 && this.editedItem.idListPallet) {
                    selectedPallet = {
                        id: this.editedItem.idListPallet,
                        name: this.editedItem.palletName
                    } as IListPalletType;
                }

                if (!selectedPallet && this.editedIndex === -1) {
                    selectedPallet = this.PalletTypesList.find(
                        p => p.name && p.name.toLowerCase() === "unknown"
                    ) as IListPalletType;
                }

                if (!selectedPallet) {
                    this.showMessageWarning('Pallet type is required.');
                    return;
                }

                this.editedItem.idListPallet = selectedPallet.id;
                this.editedItem.palletName = selectedPallet.name;

                if (this.editedIndex > -1) {
                    this.close();
                    this.$emit('editInboundDetail', this.editedItem);
                    Object.assign(this.InboundDetailList[this.editedIndex], this.editedItem);
                } else {
                    const inboundId = this.InboundId || (this.SelectedInbound ? this.SelectedInbound.id : "");

                    if (!inboundId) {
                        this.showMessageWarning('No inbound selected.');
                        return;
                    }

                    this.editedItem.idInbound = inboundId;
                    this.$emit('saveInboundDetail', this.editedItem);
                }

                this.close();
            }
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteInboundDetail(inboundDetail: IInboundDetail) {
        if (this.selectedInboundDetail.length > 0) {
            this.$emit('deleteInboundDetail', inboundDetail);
            this.close();
        }
    }

    close(): void {
        this.dialog = false;

        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            this.selectedPalletId = "";
            this.originalPalletName = "";
        });
    }

    printInboundDetail() {
        this.dialogPrinting = false;
        this.$emit('printInboundDetail', this.selectedFormatToPrint);
    }

    select(item: IInboundDetail): void {
        let index: number = this.selectedInboundDetail.findIndex(w => w.id === item.id);

        if (index === -1) {
            this.selectedInboundDetail = [item];
            this.$emit('input', item);
        } else {
            let inboundDetail = this.selectedInboundDetail.find(w => w.id === item.id);

            if (!inboundDetail) {
                this.selectedInboundDetail = [];
                this.$emit('input', null);
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }

    async onXlsSelected(file: File | null) {
        this.xlsErrors = [];
        this.xlsPreviewRows = [];

        if (!file) return;

        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });

            const sheetName = workbook.SheetNames[0];

            if (!sheetName) {
                this.xlsErrors.push('No sheet found in Excel file.');
                return;
            }

            const sheet = workbook.Sheets[sheetName];

            const rows: any[] = XLSX.utils.sheet_to_json(sheet, {
                defval: null,
                raw: true
            });

            if (!rows.length) {
                this.xlsErrors.push('Excel file is empty.');
                return;
            }

            const normalizeKey = (k: string) => (k || '').toString().trim().toLowerCase();

            const findValue = (obj: any, desired: string) => {
                const desiredNorm = normalizeKey(desired);
                const key = Object.keys(obj).find(k => normalizeKey(k) === desiredNorm);
                return key ? obj[key] : null;
            };

            const preview: any[] = [];
            let rowNumber = 1;

            for (const r of rows) {
                const goodCodeRaw = findValue(r, 'good code');
                const weightRaw = findValue(r, 'weight');
                const casesRaw = findValue(r, 'cases');
                const bbdRaw = findValue(r, 'bbd');
                const batchCodeRaw = findValue(r, 'batch code');

                const batchCode = (batchCodeRaw !== null && batchCodeRaw !== undefined ? batchCodeRaw : '').toString().trim();
                const goodCode = (goodCodeRaw !== null && goodCodeRaw !== undefined ? goodCodeRaw : '').toString().trim();
                const weight = this.parseNumber(weightRaw);
                const bbd = this.parseBbdToIso(bbdRaw);
                const cases = this.parseNumber(casesRaw);

                const matchedGood = this.GoodList.find(g =>
                    (g.code || '').toString().trim().toLowerCase() === goodCode.toLowerCase()
                );

                let isValid = true;
                const messages: string[] = [];

                if (!goodCode) {
                    isValid = false;
                    messages.push('Missing good code');
                }

                if (!matchedGood) {
                    isValid = false;
                    messages.push('Good code not found in GoodList');
                }

                if (weight === null || Number.isNaN(weight)) {
                    isValid = false;
                    messages.push('Invalid weight');
                } else if (weight < 0) {
                    isValid = false;
                    messages.push('Weight must be >= 0');
                }

                if (cases === null || Number.isNaN(cases)) {
                    isValid = false;
                    messages.push('Invalid cases');
                } else if (cases <= 0) {
                    isValid = false;
                    messages.push('Cases must be > 0');
                }

                if (bbdRaw !== null && bbdRaw !== undefined && bbdRaw !== '' && bbd === null) {
                    isValid = false;
                    messages.push('Invalid bbd');
                }

                if (matchedGood && (!matchedGood.amountPerBox || matchedGood.amountPerBox <= 0)) {
                    isValid = false;
                    messages.push('Good amountPerBox is 0, goodsPerCase cannot be calculated');
                }

                preview.push({
                    rowNumber,
                    goodCode,
                    batchCode,
                    weight,
                    cases,
                    bbd,
                    matchedGoodId: matchedGood ? matchedGood.id : null,
                    matchedGoodName: matchedGood ? matchedGood.name : null,
                    isValid,
                    message: messages.join(' | ') || 'OK'
                });

                rowNumber++;
            }

            this.xlsPreviewRows = preview;

            const sample = rows[0] || {};
            const keys = Object.keys(sample).map(k => k.toLowerCase());

            if (
                !keys.includes('good code') ||
                !keys.includes('weight') ||
                !keys.includes('cases') ||
                !keys.includes('bbd') ||
                !keys.includes('batch code')
            ) {
                this.xlsErrors.push("Headers not exactly matching 'good code', 'weight', 'cases', 'batch code', 'bbd'. Verify the column names.");
            }
        } catch (err) {
            const e = err as any;
            const msg = (e && e.message) ? e.message : String(e);
            this.xlsErrors.push('Error reading Excel: ' + msg);
        }
    }

    parseNumber(v: any): number | null {
        if (v === null || v === undefined || v === '') return null;

        if (typeof v === 'number') return v;

        const s = v.toString().trim().replace(',', '.');
        const n = Number(s);

        return Number.isFinite(n) ? n : null;
    }

    parseBbdToIso(v: any): string | null {
        if (v === null || v === undefined || v === '') return null;

        if (typeof v === 'number') {
            const d = XLSX.SSF.parse_date_code(v);

            if (!d) return null;

            const yyyy = String(d.y).padStart(4, '0');
            const mm = String(d.m).padStart(2, '0');
            const dd = String(d.d).padStart(2, '0');

            return `${yyyy}-${mm}-${dd}`;
        }

        if (v instanceof Date) {
            return moment(v).format('YYYY-MM-DD');
        }

        const s = v.toString().trim();

        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

        if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(s)) {
            const parts = s.split(/[-/]/);
            const dd = parts[0];
            const mm = parts[1];
            const yyyy = parts[2];

            return `${yyyy}-${mm}-${dd}`;
        }

        const m = moment(s, ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY'], true);

        return m.isValid() ? m.format('YYYY-MM-DD') : null;
    }

    confirmXlsImport() {
        if (!this.canConfirmXlsImport) return;

        const pallet = this.xlsSelectedPallet;

        if (!pallet || !pallet.id) {
            this.showMessageWarning('Pallet type is required.');
            return;
        }

        const inboundId =
            this.InboundId && this.InboundId !== ""
                ? this.InboundId
                : this.SelectedInbound && this.SelectedInbound.id
                    ? this.SelectedInbound.id
                    : "";

        if (!inboundId) {
            console.warn("No inbound selected in child during XLS import", {
                InboundId: this.InboundId,
                SelectedInbound: this.SelectedInbound,
                uploadXlsDialog: this.uploadXlsDialog,
                xlsPreviewRows: this.xlsPreviewRows.length
            });

            this.showMessageWarning('No inbound selected.');
            return;
        }

        const validRows = this.xlsPreviewRows.filter(r => r.isValid);

        const inboundDetails: IInboundDetail[] = validRows.map(r => {
            const good = this.GoodList.find(g => g.id === r.matchedGoodId) as IGood;

            const goodsPerCase = good && good.amountPerBox ? Number(good.amountPerBox) : 0;
            const palletsAmount = 1;
            const casesPerPallet = Number(r.cases || 0);
            const totalCases = palletsAmount * casesPerPallet;
            const totalGoods = totalCases * goodsPerCase;

            const detail: IInboundDetail = {
                id: "",
                idInbound: inboundId,
                idGood: good.id,
                goodName: good.name,

                idListPallet: pallet.id,
                palletName: pallet.name,

                palletsAmount,
                casesPerPallet,
                totalCases,

                goodsPerCase,
                totalGoods,

                bestBeforeDate: r.bbd ? new Date(r.bbd) : null,

                inDeliveryNote: 0,

                language: r.batchCode || "",
                documentation: this.IsDouanaDocumentRequiredByInboundType,

                sku: good.sku || "",
                casesLoss: 0,

                weight: r.weight || 0,
                goodCode: good.code || ""
            };

            return detail;
        });

        this.$emit('importInboundDetailsFromXls', inboundDetails);

        this.showMessageInfo(`${inboundDetails.length} inbound detail(s) prepared from XLS.`);
        this.closeUploadXlsDialog();
    }

    get isCompanySource(): boolean {
        return !!this.SelectedInbound &&
            !!this.CompanyId &&
            this.CompanyId === this.SelectedInbound.idCompanySource;
    }

    get AvailablePalletTypes(): IListPalletType[] {
        const pallets = [...(this.PalletTypesList || [])];

        if (this.editedIndex === -1) {
            return pallets;
        }

        if (this.isCompanySource) {
            return pallets;
        }

        if (!this.editedItem.idListPallet) {
            return pallets;
        }

        const current = pallets.find(p => p.id === this.editedItem.idListPallet);

        if (!current) {
            return pallets;
        }

        const filtered = pallets.filter(p => p.id !== current.id);

        return [current, ...filtered];
    }

    resolveSelectedPallet(item: IInboundDetail): IListPalletType {
        const palletFromDestinationList = (this.PalletTypesList || []).find(p => p.id === item.idListPallet);

        if (palletFromDestinationList) {
            return palletFromDestinationList;
        }

        return {
            id: item.idListPallet,
            name: item.palletName || 'Current pallet'
        } as IListPalletType;
    }
}
